/* Gadget Mint — Product page: variant picker.
   Loaded only on the product template. No inline JS anywhere. */
(function () {
  var root = document.querySelector('[data-product-root]');
  if (!root) return;

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    return 'Rs. ' + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
  }

  var priceEl        = root.querySelector('[data-product-price]');
  var comparePriceEl = root.querySelector('[data-product-compare-price]');
  var stockNoteEl    = root.querySelector('[data-stock-note]');
  var atcButton      = root.querySelector('[data-atc-button]');
  var atcText        = root.querySelector('[data-atc-text]');
  var skuEl          = root.querySelector('[data-product-sku]');
  var qtyInput       = root.querySelector('[data-product-form] input[name="quantity"]');
  var variantIdInput = root.querySelector('[data-variant-id-input]');
  var mainImgEl      = root.querySelector('[data-gallery-main] img');
  var deliveryBox    = root.querySelector('[data-delivery-info]');
  var deliveryTotalEl = deliveryBox ? deliveryBox.querySelector('[data-delivery-total]') : null;
  var deliveryChargeCents = deliveryBox ? (parseInt(deliveryBox.getAttribute('data-delivery-charge-cents'), 10) || 0) : 0;

  var currentVariant = null;

  var productData = null;
  var jsonEl = document.querySelector('[data-product-json]');
  if (jsonEl) {
    try { productData = JSON.parse(jsonEl.textContent); } catch (e) { productData = null; }
  }

  function baseFilename(url) {
    return (url || '').split('?')[0].split('/').pop();
  }

  /* Sets the main image (src + srcset together — see note in applyVariant)
     from a given thumbnail and marks it active. Shared by the thumbnail
     click handler below and by variant-driven gallery sync in applyVariant,
     so there's exactly one place that knows how to point the main image at
     a thumbnail. */
  function activateThumb(thumb) {
    if (!thumb || !mainImgEl) return;
    root.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
    mainImgEl.src = thumb.getAttribute('data-full-src');
    mainImgEl.srcset = thumb.getAttribute('data-full-srcset');
  }

  /* Gallery thumbnails: clicking (mouse or touch tap, both dispatch 'click')
     previews that image. Two listeners delegated on the thumbs wrapper —
     one per event type, each covering every thumbnail — instead of binding
     a handler per button. Enter/Space is handled explicitly rather than
     relied on as an implicit side effect of using <button> elements, since
     that default activation isn't guaranteed to fire in every environment.
     This runs unconditionally (not gated behind variant data below) because
     the thumbnail row renders whenever a product has multiple media,
     including single-variant products. */
  var thumbsWrap = root.querySelector('.product-gallery__thumbs');
  if (thumbsWrap) {
    thumbsWrap.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-gallery-thumb]');
      if (thumb) activateThumb(thumb);
    });
    thumbsWrap.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      var thumb = e.target.closest('[data-gallery-thumb]');
      if (!thumb) return;
      e.preventDefault();
      activateThumb(thumb);
    });
  }

  function renderPrice() {
    if (!currentVariant || !priceEl) return;

    var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    var total = currentVariant.price * qty;

    priceEl.textContent = formatMoney(total);

    if (comparePriceEl) {
      var compareBase = 0;
      if (currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price) {
        compareBase = currentVariant.compare_at_price * qty;
      }
      if (compareBase > total) {
        comparePriceEl.textContent = formatMoney(compareBase);
        comparePriceEl.style.display = '';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }
  }

  if (qtyInput) {
    qtyInput.addEventListener('change', function () {
      renderPrice();
    });
  }

  /* "Total Payable (1 Piece)" is always priced for a single unit, so it
     tracks the selected variant only — never the quantity input. */
  function renderDeliveryTotal() {
    if (!currentVariant || !deliveryTotalEl) return;
    deliveryTotalEl.textContent = formatMoney(currentVariant.price + deliveryChargeCents);
  }

  /* ---------------- variant picker ---------------- */
  if (!productData || !productData.variants || !productData.variants.length || !variantIdInput) return;

  var variants = productData.variants;
  var pills = Array.prototype.slice.call(root.querySelectorAll('[data-variant-pill]'));

  currentVariant = variants.filter(function (v) {
    return v.id === parseInt(variantIdInput.value, 10);
  })[0] || variants[0];

  var selected = {};
  [currentVariant.option1, currentVariant.option2, currentVariant.option3].forEach(function (val, i) {
    if (val !== null && val !== undefined) selected[i + 1] = val;
  });

  function findMatchingVariant() {
    return variants.filter(function (v) {
      return (selected[1] === undefined || v.option1 === selected[1]) &&
             (selected[2] === undefined || v.option2 === selected[2]) &&
             (selected[3] === undefined || v.option3 === selected[3]);
    })[0];
  }

  function updatePillStates() {
    pills.forEach(function (pill) {
      var position = pill.getAttribute('data-option-position');
      var value = pill.getAttribute('data-option-value');
      pill.classList.toggle('is-selected', selected[position] === value);

      var test = {};
      for (var k in selected) test[k] = selected[k];
      test[position] = value;

      var available = variants.some(function (v) {
        return (test[1] === undefined || v.option1 === test[1]) &&
               (test[2] === undefined || v.option2 === test[2]) &&
               (test[3] === undefined || v.option3 === test[3]) &&
               v.available;
      });
      pill.toggleAttribute('disabled', !available);
    });

    root.querySelectorAll('[data-option-position]').forEach(function (group) {
      var labelEl = group.querySelector('[data-selected-value]');
      if (labelEl) labelEl.textContent = selected[group.getAttribute('data-option-position')] || '';
    });
  }

  function applyVariant(variant) {
    if (!variant) return;
    currentVariant = variant;
    variantIdInput.value = variant.id;

    renderPrice();
    renderDeliveryTotal();

    if (atcButton) atcButton.toggleAttribute('disabled', !variant.available);
    if (atcText) atcText.textContent = variant.available ? 'Add to Cart' : 'Sold Out';

    if (stockNoteEl) {
      if (variant.available && variant.inventory_management &&
          variant.inventory_quantity > 0 && variant.inventory_quantity <= 18) {
        stockNoteEl.textContent = '🔥 Limited Stock – Only ' + variant.inventory_quantity + ' Pieces Left';
      } else {
        stockNoteEl.textContent = '';
      }
    }

    if (skuEl) skuEl.textContent = variant.sku || 'N/A';

    /* Gallery sync — reuses activateThumb() so variant switching and manual
       thumbnail clicks stay in lockstep instead of having two independent
       code paths that could drift apart.

       Thumbnails are matched by filename, not by id: `product.media[].id`
       (used on the thumb elements) and `variant.featured_image.id` are two
       different Shopify id namespaces (Media vs legacy Image) and never
       match each other, even when they're the exact same picture. */
    if (mainImgEl) {
      if (variant.featured_image) {
        var targetFile = baseFilename(variant.featured_image.src);
        var thumbEls = root.querySelectorAll('[data-gallery-thumb]');
        var thumb = null;
        for (var i = 0; i < thumbEls.length; i++) {
          if (baseFilename(thumbEls[i].getAttribute('data-full-src')) === targetFile) { thumb = thumbEls[i]; break; }
        }
        if (thumb) {
          activateThumb(thumb);
        } else if (variant.featured_image.src) {
          root.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
          var base = variant.featured_image.src.split('?')[0];
          var withWidth = function (w) { return base + '?width=' + w; };
          mainImgEl.src = withWidth(900);
          mainImgEl.srcset = withWidth(450) + ' 450w, ' + withWidth(700) + ' 700w, ' +
                              withWidth(900) + ' 900w, ' + withWidth(1200) + ' 1200w';
        }
      } else {
        /* Variant has no image of its own — keep showing the product's default image. */
        root.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        var defaultThumb = root.querySelector('[data-gallery-thumb]');
        if (defaultThumb) defaultThumb.classList.add('is-active');
        mainImgEl.src = mainImgEl.getAttribute('data-default-src');
        mainImgEl.srcset = mainImgEl.getAttribute('data-default-srcset');
      }
    }

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
  }

  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      if (pill.hasAttribute('disabled')) return;
      selected[pill.getAttribute('data-option-position')] = pill.getAttribute('data-option-value');
      updatePillStates();
      applyVariant(findMatchingVariant());
    });
  });

  updatePillStates();
  renderPrice();
  renderDeliveryTotal();
})();

/* ============================================================
   Frequently Bought Together
   `recommendations.products` is only ever populated on a request to
   routes.product_recommendations_url — it's always empty when rendered
   inline as part of a normal page load. So the section lives in its own
   file (product-recommendations.liquid) and gets fetched here via the
   Section Rendering API, matching how the cart drawer refreshes itself.
   If there's nothing to recommend, the placeholder is removed outright
   rather than left as a blank section.
   ============================================================ */
(function () {
  var container = document.querySelector('[data-product-recommendations]');
  if (!container) return;
  var url = container.getAttribute('data-url');
  if (!url) { container.remove(); return; }

  fetch(url)
    .then(function (r) { return r.ok ? r.text() : ''; })
    .then(function (html) {
      if (!html) { container.remove(); return; }
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var content = doc.querySelector('[data-product-recommendations-content]');
      if (content) container.replaceWith(content);
      else container.remove();
    })
    .catch(function () { container.remove(); });
})();

/* ============================================================
   Recently Viewed — "Pick up where you left off"
   Shopify has no native recently-viewed API, so the handle list is
   tracked client-side in localStorage (same pattern as the wishlist:
   a plain array of handles, resolved to full product data via the
   /products/{handle}.js AJAX endpoint on the page that displays them).
   ============================================================ */
(function () {
  var STORAGE_KEY = 'gadgetmint_recently_viewed';
  var MAX_ITEMS = 12;

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var jsonEl = document.querySelector('[data-product-json]');
  var currentHandle = null;
  if (jsonEl) {
    try { currentHandle = JSON.parse(jsonEl.textContent).handle; } catch (e) { currentHandle = null; }
  }

  var handles = [];
  try { handles = JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch (e) { handles = []; }

  var toShow = handles.filter(function (h) { return h !== currentHandle; }).slice(0, 4);

  if (currentHandle) {
    var updated = [currentHandle].concat(handles.filter(function (h) { return h !== currentHandle; }));
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(updated.slice(0, MAX_ITEMS))); } catch (e) {}
  }

  var section = document.querySelector('[data-recently-viewed]');
  var grid = document.querySelector('[data-recently-viewed-grid]');
  if (!section || !grid || !toShow.length) return;

  Promise.all(toShow.map(function (handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  })).then(function (products) {
    products = products.filter(Boolean);
    if (!products.length) return; /* section stays hidden — never show an empty block */

    grid.innerHTML = products.map(function (p) {
      var img = p.featured_image || (p.images && p.images[0]) || '';
      var price = (p.price / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return '<div class="product-card">' +
        '<a href="' + p.url + '" class="product-card__media-link">' +
          '<div class="product-card__media zoom-wrap"><img src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy"></div>' +
        '</a>' +
        '<div class="product-card__body">' +
          '<a href="' + p.url + '"><h3 class="product-card__title">' + escapeHtml(p.title) + '</h3></a>' +
          '<div class="price">Rs. ' + price + '</div>' +
        '</div>' +
      '</div>';
    }).join('');

    section.style.display = '';
  });
})();
